window.RIV = window.RIV || {};

export const setGlobalVariable = (key, value) => {
  window.RIV[key] = value;
};

export const getGlobalVariable = key => window.RIV[key] || {};
